import { render, staticRenderFns } from "./ServiceInit.vue?vue&type=template&id=591653e2&"
import script from "./ServiceInit.vue?vue&type=script&lang=js&"
export * from "./ServiceInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports